import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { connect } from 'react-redux'
import { arreglo, forMiles, mapStateToProps, secondsToString, sumarArreglo } from "../../funtComponents/models/buscar";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


//


function TablaDerechaCombinados(props) {
  
  const valueSalientes = Object.values(props.salientes).length
  const valueEntrantes = Object.values(props.entrantes).length
  const arregloEntrantes = Object.values(arreglo(props.entrantes, props.rightAnexos));
  
  const total = (valueSalientes+valueEntrantes)
  
  const tiempoTotal = secondsToString((sumarArreglo(props.entrantes,'billsec')+sumarArreglo(props.salientes, 'billsec')))
  const tiempoTotalRing = secondsToString((sumarArreglo(props.entrantes,'ringtime')+sumarArreglo(props.salientes, 'ringtime'))/total || 0)


  sumarArreglo(arregloEntrantes, 'ring')
  function createData(name, set1) {
    return { name, set1};
  }
  
  const rows = [
    createData('Total de Llamadas:', forMiles(total)),
    createData('Tiempo Total:', tiempoTotal),
    createData('Promedio Ring:', tiempoTotalRing),
  ];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ maxWidth: '100%' }} aria-label="customized table">
        <TableHead>
          <TableRow >
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', fontWeight: 600 }}>
              Llamadas Entrantes | Salientes
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="right">{row.set1}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}


export default connect(mapStateToProps, null)(TablaDerechaCombinados);
